// import {CircleBufferGeometry} from "three";

import {
    BufferGeometry, Float32BufferAttribute, Vector2, Vector3
} from 'three';

export class FullHeightRoundedRect extends BufferGeometry {

    constructor(width = 3, height = 1, segments = 8, wSegments = 10) {

        super();

        this.type = 'FullHeightRoundedRect';

        const radius = height * 0.5;

        this.parameters = {
            radius,
            height,
            width,
            segments,
            wSegments
        };

        segments = Math.max(2, segments);
        wSegments = Math.max(2, wSegments);
        const dw2 = 0.5 * Math.max(width - radius * 2, 0);

        // buffers

        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];

        // helper variables

        const vertex = new Vector3();
        const uv = new Vector2();

        // LEFT
        // center point

        vertices.push(-dw2, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);

        for (let s = 0; s <= segments; s += 1) {

            const segment = (0.5 + (s / segments)) * Math.PI;

            // vertex

            vertex.x = -dw2 + radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);

            vertices.push(vertex.x, vertex.y, vertex.z);

            // normal

            normals.push(0, 0, 1);

            // uvs

            uv.x = (vertex.x / radius + 1) / 2;
            uv.y = (vertex.y / radius + 1) / 2;

            uvs.push(uv.x, uv.y);

        }

        // indices

        for (let i = 1; i <= segments; i += 1) {

            indices.push(i, i + 1, 0);

        }

        // RIGHT
        // center point

        vertices.push(dw2, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);

        for (let s = 0; s <= segments; s += 1) {

            const segment = (-0.5 + (s / segments)) * Math.PI;

            // vertex

            vertex.x = dw2 + radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);

            vertices.push(vertex.x, vertex.y, vertex.z);

            // normal

            normals.push(0, 0, 1);

            // uvs

            uv.x = (vertex.x / radius + 1) / 2;
            uv.y = (vertex.y / radius + 1) / 2;

            uvs.push(uv.x, uv.y);

        }

        // indices

        for (let i = segments + 3; i <= 2 * segments + 3 - 1; i += 1) {

            indices.push(i, i + 1, segments + 2);

        }

        // CENTER
        for (let s = 0; s <= wSegments; s += 1) {

            // vertices

            vertex.x = dw2 * (-1 + (s * 2) / wSegments);

            vertex.y = -radius;
            vertices.push(vertex.x, vertex.y, vertex.z);

            vertex.y = radius;
            vertices.push(vertex.x, vertex.y, vertex.z);

            // normal

            normals.push(0, 0, 1);
            normals.push(0, 0, 1);

            // uvs

            uv.x = (vertex.x / radius + 1) / 2;
            uv.y = -0.5;

            uvs.push(uv.x, uv.y);

            uv.x = (vertex.x / radius + 1) / 2;
            uv.y = 0.5;

            uvs.push(uv.x, uv.y);

        }

        // indices

        indices.push((segments + 3) * 2, (segments + 3) * 2 + 1, 0);
        indices.push(0, segments + 1, (segments + 3) * 2);
        indices.push(0, (segments + 3) * 2 + 1, 1);

        const endCenterSeg = (segments + 3) * 2 + (wSegments - 1) * 2 - 3;
        const endCenterI = segments + 2;

        indices.push(endCenterSeg + 1, endCenterI, endCenterSeg + 2);
        indices.push(endCenterI, endCenterSeg + 1, segments + 3);
        indices.push(endCenterI, 2 * segments + 3, endCenterSeg + 2);

        for (let i = (segments + 3) * 2; i <= endCenterSeg; i += 1) {

            if (i % 2 === 1) {
                indices.push(i, i + 1, i + 2);
            } else {
                indices.push(i, i + 2, i + 1);
            }

        }

        // build geometry

        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

    }

    static fromJSON(data) {

        return new FullHeightRoundedRect(data.radius, data.segments, data.wSegments);

    }

}
